import {Point} from './pointWidget.model';
import {TranslateService} from '@ngx-translate/core';

export class IndicatorBoxModel {
  public pointData: Point;
  public penetration: Point;
  public t: any;
  public options: any;

  /**
   *
   * @param {Point[]} points
   * @param options {}:
   * - additional_info <string>: valore addizionale, il valore (stringa) che viene inserito, viene stampato a video subito dopo il valore principale
   * - differenzial_algebraic <boolean>: TRUE inserisce il valore di differenziale algebrico '∆', FALSE di default
   * - value_diff <string>: se questo valore è settato, nasconde la riga con del valore precedente e la sostituisce con il testo assegnato a questa variabile
   * - decimal_value <int>: di default mette 2 decimali, altrimenti il valore che gli viene passato
   * - decimal_prec_value <int>: di default mette 2 decimali, altrimenti il valore che gli viene passato
   * - converter_million <boolean>: TRUE divide per 1000 e mette la sigla M
   * - unit_period_prec <string>: unità di misura della sezione "profondità"
   * @param t
   */
  constructor(points: Point[], options: any = {}, t: any = null) {
    if (points.length > 0) {
      this.pointData = points[0];
    }
    if (points.length > 1) {
      this.penetration = points[1]
    }
    this.options = options;
    if (this.options.decimal_value == null) {
      this.options.decimal_value = 2;
    }
    if (this.options.decimal_prec_value == null) {
      this.options.decimal_prec_value = 2;

    }

    if (this.options.unit_period_prec != null) {
      if (this.penetration != null)
        this.penetration.unitOfMeasure = this.options.unit_period_prec;

    }
    this.t = t;
  }
}

export class IndicatorOtherModel extends Point {

  difference?: any;
  other?: any;
}



// WEBPACK FOOTER //
// ./src/app/models/indicator-box.model.ts